export default __webpack_public_path__ + "static/media/icon-hand-dark.eac82cdd.svg";